module.exports = __webpack_public_path__ + "static/img/M-6.06745fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mzhongfu/M-6.png
// module id = bBuy
// module chunks = 0